import { render, staticRenderFns } from "./GenaratorOrderPageSearchTable.vue?vue&type=template&id=6c20d5ef"
import script from "./GenaratorOrderPageSearchTable.vue?vue&type=script&lang=js"
export * from "./GenaratorOrderPageSearchTable.vue?vue&type=script&lang=js"
import style0 from "./GenaratorOrderPageSearchTable.vue?vue&type=style&index=0&id=6c20d5ef&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports